module.exports = __webpack_public_path__ + "img/bet-token.f602b663.png";